import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SetPartiesRequest } from 'app/generated/backend/shipment/api/set-parties-request';
import { SetPartiesResponse } from 'app/generated/backend/shipment/api/set-parties-response';

@Injectable()
export class SetPartiesHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	post(
		request: SetPartiesRequest
	): Observable<JsonResourceResponse<SetPartiesResponse>> {
		return this.http.post<JsonResourceResponse<SetPartiesResponse>>('api/v1/shipment/setParties', request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		SetPartiesHandlerService
	]
})
export class SetPartiesHandlerModule { }
